import Shuffle from 'shufflejs'

Shuffle.ShuffleItem.Scale.HIDDEN = 1

export default function initShuffle(page, addons = []) {
  page.querySelectorAll('[data-shuffle]').forEach(el => {
    const shuffle = new Shuffle(el, {
      itemSelector: '[data-shuffle-item]',
      speed: 300,
    })

    el.querySelectorAll('[data-lazy-image]').forEach(img => {
      img.addEventListener('load', () => {
        shuffle.layout()
      })
    })

    addons.forEach(addon => addon(page, shuffle, el))
  })
}
